import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MomentControl } from '../components/wall/MomentControl';
import { DeskTopBar } from '../components/desk/DeskTopBar';
import { ConversationPanel } from '../components/desk/ConversationPanel';
import { DeskStageArea } from '../components/desk/DeskStageArea';
import { AgentsAtWork } from '../components/desk/AgentsAtWork';
import { WaitingStack } from '../components/desk/WaitingStack';
import { useDeskStage } from '../hooks/useDeskStage';
import { useDb } from '../hooks/useDb';
import { Toast } from '../components/ui/Toast';
import { NoodstopSheet } from '../components/ui/NoodstopSheet';

/** Commandocentrum on the desk monitor (2560×1440 and 1920×1080): a living operations room, calm enough to keep open all day. */
export function CommandCenter() {
  const stage = useDeskStage();
  const stoppedBy = useDb(t => t.meta.stoppedBy);
  useEffect(() => {
    if (!stage.toast) return;
    const id = window.setTimeout(stage.dismissToast, 3500);
    return () => window.clearTimeout(id);
  }, [stage.toast, stage.dismissToast]);
  return <div className="relative flex min-h-screen w-full flex-col overflow-hidden bg-night-950 text-ink xl:h-screen" data-id="element-1935" data-mp="33lqa1w3s08ou">
      {/* Soft glow behind Anna — neutral during work */}
      <div aria-hidden className="pointer-events-none absolute left-[-10%] top-[5%] h-[70vh] w-[50vw] rounded-full opacity-60" style={{
      background: 'radial-gradient(closest-side, rgb(var(--accent) / 0.08), transparent)'
    }} data-id="element-1936" data-mp="3djeejdr6ouk7" />

      <MomentControl index={stage.momentIndex} count={stage.momentCount} title={stage.moment.title} onPrev={stage.prev} onNext={stage.next} data-id="element-1937" data-mp="3mhgahew28x0m" />
      <DeskTopBar stage={stage} data-id="element-1938" data-mp="4hr18xbb2sj" />

      <main className="relative z-10 grid min-h-0 flex-1 grid-cols-1 gap-6 px-6 py-5 lg:grid-cols-[minmax(320px,30%)_1fr] xl:grid-rows-[minmax(0,1fr)] xl:grid-cols-[minmax(340px,27%)_minmax(0,1fr)_minmax(360px,25%)] 2xl:gap-8" data-id="element-1939" data-mp="3q3mldvcbdc">
        <ConversationPanel stage={stage} data-id="element-1940" data-mp="a01ow0vfsbjx" />
        <DeskStageArea stage={stage} data-id="element-1941" data-mp="3gkpop65a6gyy" />
        <aside className="flex min-h-0 flex-col gap-4 lg:col-span-2 xl:col-span-1" data-id="element-1942" data-mp="3ghjytootvb26">
          <div className="flex min-h-0 flex-[3] flex-col" data-id="element-1943" data-mp="3bm4k6uizxb4p">
            <AgentsAtWork stage={stage} data-id="element-1944" data-mp="3q9pousvirieq" />
          </div>
          <div className="flex min-h-0 flex-[2] flex-col" data-id="element-1945" data-mp="3qbk882r572gp">
            <WaitingStack stage={stage} data-id="element-1946" data-mp="3lhps19aqx5md" />
          </div>
        </aside>
      </main>

      <div className="pointer-events-none fixed inset-x-0 bottom-8 z-50 flex justify-center px-4" data-id="element-1947" data-mp="33ypmdm129fv">
        <AnimatePresence data-id="element-1948" data-mp="3ubufdiqo7yx5">
          {stage.toast && <motion.div key={stage.toast.id} className="pointer-events-auto" initial={{
          opacity: 0,
          y: 12,
          scale: 0.98
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 8
        }} transition={{
          duration: 0.2,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-1949" data-mp="3udf9j792pfuh">
              <Toast tone={stage.toast.tone} title={stage.toast.text} onClose={stage.dismissToast} data-id="element-1950" data-mp="29w9bjbx9r5bu" />
            </motion.div>}
        </AnimatePresence>
      </div>

      <NoodstopSheet open={stage.stopped} onResume={stage.resume} stoppedBy={stoppedBy} data-id="element-1951" data-mp="uc09vztjx6ji" />
    </div>;
}